/**
 * The AI-token gate every AI feature in the practice client draws the same way: Cura, and the referral summary draft
 * (tasks/referrals-platform-architecture.md §16, T1).
 *
 *   premium practice   never locked, never warned
 *   balance below 0    locked
 *   0 < balance <= 100 warned (the balance is shown)
 *   unreadable         neither: the servers that do check refuse it
 *
 * `balance` may arrive as a string: the group row stores it as text, and the `tokenBalanceChanged` socket event sends
 * `toFixed(2)`.
 */
export interface AiTokenGate {
  locked: boolean;
  /** The balance to show in the low-balance warning, or null when there is nothing to warn about. */
  lowBalance: number | null;
}

export const AI_LOW_BALANCE_LIMIT = 100;

export function aiTokenGate(isPremium: boolean | null | undefined, balance: number | string | null | undefined): AiTokenGate {
  if (isPremium === true) return { locked: false, lowBalance: null };
  const value = typeof balance === 'number' ? balance : parseFloat(String(balance ?? ''));
  if (Number.isNaN(value)) return { locked: false, lowBalance: null };
  if (value < 0) return { locked: true, lowBalance: null };
  return { locked: false, lowBalance: value > 0 && value <= AI_LOW_BALANCE_LIMIT ? value : null };
}
